export default __webpack_public_path__ + "static/mount_roof-01da43b88bde3c9d0433ec77ba10b88a.jpg";